import uuid from 'uuid';
import { db, storage } from '../../../firebase';

export const startAddWebsitePortfolio = (portfolio, fileData) => {
  const fileId = uuid.v4();
  portfolio.fileId = fileId;

  return (dispatch) => {
    return db.createWebsitePortfolio(portfolio)
    .then(() => fileData && storage.uploadPortfolioFile(fileId, fileData));
  }
}

export const startEditWebsitePortfolio = (id, updates, fileData) => {
  console.log("fileData:", fileData);
  const fileId = updates.fileId ? updates.fileId : uuid.v4();
  updates.fileId = fileId;

  if (fileData) {
    return (dispatch) => {
      return db.updateWebsitePortfolio(id, updates)
      .then(() => fileData && storage.uploadPortfolioFile(fileId, fileData));
    };
  } else {
    return (dispatch) => {
      return db.updateWebsitePortfolio(id, updates)
    };
  }
}

export const startRemoveWebsitePortfolio = (id) => {
  return (dispatch) => db.deleteWebsitePortfolio(id);
};

export const setWebsitePortfolio = (portfolio) => ({
  type: 'SET_WEBSITE_PORTFOLIO',
  portfolio
});

export const startSetWebsitePortfolio = () => {
  return (dispatch) => {
    return db.getWebsitePortfolio().on('value', snapshot => {
      const promises = [];
      const portfolio = [];

      snapshot.forEach(childSnapshot => {
        portfolio.push({ id: childSnapshot.key, ...childSnapshot.val() });
      });

      portfolio.forEach(item => {
        if(item.fileId) {
          promises.push(
            storage.getPortfolioDownloadURL(item.fileId)
              .then(result => {
                item.downloadURL = result
              })
              .catch(error => console.log("LOAD PORTFOLIO URL FAILED:", error))
          );
        }
      });

      Promise.all(promises).then(() => {
        dispatch(setWebsitePortfolio(portfolio));
        return dispatch({ type: 'VALIDATE_WEBSITE' });
      });
    });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/website/portfolio.js